// extracted by mini-css-extract-plugin
export default {"tip_box":"index_tip_box_Qov7F","tip":"index_tip_TDq3F"};